import { render } from "./ContractModelCreate.vue?vue&type=template&id=35124d68"
import script from "./ContractModelCreate.vue?vue&type=script&lang=js"
export * from "./ContractModelCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__